
<template>

    <v-content class="mt-2">
     

        <v-container class="grey lighten-5 ">
            <v-row>
                
                <v-col cols="12" md="4" sm="12" lg="4">
                    <v-combobox v-model="select_combo" item-text="semester_val" return-object :items="data_com"
                        label="Select Semester " outlined single-line dense @change="directToBank()"></v-combobox>
                </v-col>
            </v-row>
            <v-container>
            <v-row justify="center" align="center">
                <v-col cols="12" md="12" sm="12" lg="12">

                        <div class=" text-center" style="font-size:18px;font-weight: bold">

                            SUMMARY OF ACHIEVEMENT
                        </div>    
                            
                   
                </v-col>
            </v-row>
        </v-container>
            <v-row justify="center" align="center">
                <v-col cols="12" md="12" sm="12" lg="12">
                    <!-- <v-alert style="font-weight: bold" class="text-caption text-center" >
                        Grade : {{ grade_show }} : [ {{ semester_show }} | Academic Year : {{ year_show }} ]
                    </v-alert> -->
                    <div style="font-weight: bold" class="text-caption text-center" >
                        Grade : {{ grade_show }} : [ {{ semester_show }} | Academic Year : {{ year_show }} ]
                    </div>
                </v-col>
            </v-row>
            <v-row no-gutters class="mt-5">
                <v-col>
                    <v-card class="pa-2" outlined tile style="font-size:14px">
                        Accumulative Performance Percentage : <span style="color:green"> {{ totalScore.toFixed(2) }} %</span> 
                    </v-card>
                </v-col>
                <v-col order="12">
                    <v-card class="pa-2" outlined tile  style="font-size:14px">
                        Accumulative Performance Grade : <span style="color:green"> {{ getPerforgrade(totalScore) }}</span> 
                    </v-card>
                </v-col>
                <v-col order="1">
                    <v-card class="pa-2" outlined tile  style="font-size:14px">
                        Grade Description :  <span style="color:green"> {{ getRank(getPerforgrade(totalScore)) }}</span> 
                    </v-card>
                </v-col>
            </v-row>
            <v-row justify="left" align="left">
                <v-col cols="12" md="12" sm="12" lg="12">
                    <!-- <v-alert color="indigo " class="text-caption text-center" dark>
                       ATTENDANCE :  {{ attendanc_data }}
                       <br/>
                       Home Room Comment : {{ home_room }}
                    </v-alert> -->
                    <div color="indigo " class="text-caption text-center" style="font-weight:bold">
                       ATTENDANCE :  {{ attendanc_data }}
                       <br/>
                       Home Room Comment : {{ home_room }}
                    </div>
                </v-col>
            </v-row>
        </v-container>
        
        
        <v-container grid-list-md>
            <div v-if='score == 0 ' style="text-align:center">
                <v-progress-circular
                :size="50"
                :width="7"
                color="purple"
                indeterminate
                ></v-progress-circular>

            </div>    
            <v-data-table :headers="headers" :items="score" :items-per-page="20" class="elevation-1" v-else>

                <template v-slot:[`item.subject_name`]="{ item }">

                    <div v-if="item.year !='2021-2022'">
                        
                        <div v-if="(item.grade.includes('4') || item.grade.includes('5') || item.grade.includes('6') || item.grade.includes('7') || item.grade.includes('8')|| item.grade.includes('9')) && item.subject_name=='Geography'"
                                style="text-align: center;">
                            
                                Globalperspectives
                              
                            </div>

                            <div v-else style="text-align: center;">
                                <div v-if="item.subject_name=='Business Studies'"  >
                                    <div v-if= "item.year == '2025-2026'">
                                        <div v-if="item.grade.includes('10')">
                                            Enterprise
                                        </div>    
                                        <div v-else>
                                            Business Studies
                                        </div>    
                                    </div>
                                  
                                    <div v-else-if="item.year !='2024-2025' "   style="text-align: center;">
                                        Development  Studies
                                    </div> 
                                    <div v-else >
                                         {{ item.subject_name }}
                                     </div>
                                   
                                </div>
                         
                                <div v-else-if="item.year !='2024-2025' && item.subject_name=='STEAM' "   style="text-align: center;">
                                    Art and Design
                                </div>    
            
                                <div v-else >
                                    {{ item.subject_name }}
                                </div>
                            </div>
                        </div>

                    <div v-else-if="item.year =='2023-2024' && item.subject_name=='Geography' "   style="text-align: center;">
                            Globalperspectives
                        </div>
                    <div v-else-if="item.year =='2024-2025' && item.subject_name=='Geography' "   style="text-align: center;">
                            <div v-if="typeclass == 'primary'">
                                Globalperspectives
                            </div>
                            <div v-else>
                                Globalperspectives
                            </div>    
                        
                    </div>

                    <div v-else>
                            {{ item.subject_name }}
                    </div>



      

                </template>
                
                

                <template v-slot:[`item.on_going_score`]="{ item }">
                    <div v-if = "item.Total_score == 0">
                        <div v-if = "item.on_going_score == 0">
                        n/a
                    </div>
                    <div style="color:red" v-else>
                        {{ item.on_going_score }}/50
                    </div>
                    </div>   
                    <div  style="color:red" v-else>
                        {{ item.on_going_score }}/50
                    </div>    
                   

<!-- 
                    <div style="color:red">
                        {{ item.on_going_score }}/50
                    </div> -->

                </template>

                <template v-slot:[`item.exam_score`]="{ item }">
<!-- 
                    <div style="color:red">
                        {{ item.exam_score }}/50
                    </div> -->

                    <div v-if = "item.Total_score == 0">
                        <div v-if = "item.exam_score == 0">
                        n/a
                    </div>
                    <div style="color:red" v-else>
                        {{ item.exam_score }}/50
                    </div>
                    </div>   
                    <div style="color:red" v-else>
                        {{ item.exam_score }}/50
                    </div>    


                </template>

                <template v-slot:[`item.Total_score`]="{ item }">

                    <div v-if = "item.Total_score == 0">
                        n/a

                    </div>    
                    <div style="color:green" v-else>
                        {{ item.Total_score }} %
                    </div>


                    <!-- <div style="color:green" v-else>
                        {{ item.Total_score }} %
                    </div> -->


                </template>
                <template v-slot:[`item.total_percent`]="{ item }">

                <div v-if = "item.Total_score == 0">
                    n/a

                </div>    
                <div style="color:green" v-else>
                    {{getPerforgrade(item.Total_score) }}
                </div>


                <!-- <div style="color:green" v-else>
                    {{ item.Total_score }} %
                </div> -->


                </template>

                <template v-slot:[`item.total_percent_for_grade_des`]="{ item }">
                    <div v-if = "item.Total_score == 0">
                        n/a
                    </div>
                    <div v-else>
                        {{ getRank(item.total_percent_for_grade_des)  }}

                    </div>    

                 
                </template>
                <template v-slot:[`item.comment`]="{ item }">

                    {{ ConcatComent(item.name, item.comment) }}

                </template>

            </v-data-table>
            <br/>
            <div style="text-align:center">
                n/a = Not Applicable
            </div>    
        </v-container>  

       
    </v-content>
</template>

<script>
import axios from 'axios'
export default {

    name: 'view-scores',
    data: () => ({
        drawers: true,

        drawer: false,
        group: null,
        semester: 1,
        headers: [
            {
                text: 'Subject  ',
                align: 'center',
                sortable: false,
                value: 'subject_name',

            },
            { text: 'On-Going Assessment', value: 'on_going_score', align: 'center' },

            { text: 'Exam Score ', value: 'exam_score', align: 'center' },
            { text: 'Performance Percentage', value: 'Total_score', align: 'center' },
            { text: 'Performance Grade', value: 'total_percent', align: 'center' },
            { text: 'Grade Description', value: 'total_percent_for_grade_des', align: 'center' },
            { text: 'Comment', value: 'comment', align: 'start' },
        ],
        score: [

        ],
        totalScore: 0,
        select_combo: null,
        grade_show: '',
        year_show: '',
        semester_show: '',
        data_com: [
            { value: '1', semester_val: 'Semester 1 [ Term 1 ]' },
            { value: '2', semester_val: 'Semester 1 [ Term 2 ]' },
            { value: '3', semester_val: 'Semester 2 [ Term 3 ]' },
            { value: '4', semester_val: 'Semester 2 [ Term 4 ]' }

        ],

        url_api: '',
        attendanc_data:'',
        home_room :'',
        typeclass:""
    }),

    methods: {

        Logout() {


            localStorage.removeItem('hasLogin')

            this.$router.push({ name: "login" });

        },

        
        directToBank() {
            this.score = 0

            var type_class = localStorage.getItem("type_class")

            if (type_class == 'secondary') {


                this.url_api = 'http://api.isbbcambodia.org/isbb/public/api/api_reponse_secondary'


            }
            else if (type_class == 'uppersecondary') {

                this.url_api = 'http://api.isbbcambodia.org/isbb/public/api/api_response_upper_secondary'

            }
            else {

                this.url_api = 'http://api.isbbcambodia.org/isbb/public/api/api_reponse_primary'

            }
            this.semester = this.select_combo.value

            this.items = JSON.parse(localStorage.getItem("info"))

            var class_id = localStorage.getItem("class_id")

            var academic = localStorage.getItem("academic")

            var bodyFormData = new FormData();
            bodyFormData.append('id_class', class_id);
            bodyFormData.append('id_semester', this.semester);
            bodyFormData.append('id_student', this.items.student_id);
            bodyFormData.append('academic', academic)
            axios.post(this.url_api, bodyFormData).then((data) => {

                this.score = data.data.data
                this.grade_show = this.score[0].grade
                this.year_show = this.score[0].year
                this.semester_show = "Semester : " + this.score[0].semester_id + " " + this.score[0].semester_name + " "
                this.totalScore = this.score.reduce((sum, transaction) => {
                    return sum += parseFloat(transaction.Total_score);
                }, 0);  
                    // new code for count subject 
                var countSubject = this.score.reduce((c, transaction) => { 
                    console.log(transaction.Total_score)
                    if (transaction.Total_score !=0 || transaction.Total_score == null)
                        return c += 1;
                    else
                        return c += 0;
                
                  
                }, 0);
 
                
                console.log(countSubject)
                this.totalScore = parseFloat(this.totalScore) / countSubject
                // end new code
              //  console.log(this.score.length)
              //   this.totalScore = parseFloat(this.totalScore) / this.score.length

                this.items = JSON.parse(localStorage.getItem("info"))
                this.home_room = data.data.home_room
                

            }).catch((error) => {
                

            })

            this.getAttendance(this.semester)


        },

        getRank(grade) {
            var text_grade = ''
            if (grade === 'A+') {
                text_grade = 'Outstanding'
            } else if (grade === 'A') {
                text_grade = 'Excellent'
            } else if (grade === 'B+') {
                text_grade = 'Very Good'
            } else if (grade === 'B') {
                text_grade = 'Good'
            }
            else if (grade === 'C+') {
                text_grade = 'Aspiring'    
            }
             else if (grade === 'C') {
                text_grade = 'Average'
            } else if (grade === 'D') {
                text_grade = 'Pass'
            }
            
            else {
                text_grade = 'Fail'
            }
            return text_grade
        },

        ConcatComent(teacher, comment) {

            var cmt = teacher + "  : " + comment

            return cmt
        },

        getPerforgrade($percent) {
            if ($percent >= 95.00 || $percent >= 100) {
                return "A+"; 

            } else if ($percent >= 90.00 || $percent >= 94.99) {
                return "A";

            } else if ($percent >= 85.00 || $percent >= 89.99) {
                return "B+";

            } else if ($percent >= 80.00 || $percent >= 84.99) {
                return "B";

            } else if ($percent >= 75.00 || $percent >= 79.99) {
                return "C+";

            } 
            else if ($percent >= 70.00 || $percent >= 74.99) {
                return "C";

            } 
            else if ($percent >= 50.00 || $percent >= 69.99) {
                return "D";

            } else {

                return "F";
            }
        },

        // getPerforgrade($percent) {
        //     if ($percent >= 95.00 || $percent >= 100) {
        //         return "A+"; 

        //     } else if ($percent >= 90.00 || $percent >= 94.99) {
        //         return "A";

        //     } else if ($percent >= 80.00 || $percent >= 89.99) {
        //         return "B+";

        //     } else if ($percent >= 70.00 || $percent >= 79.99) {
        //         return "B";

        //     } else if ($percent >= 60.00 || $percent >= 69.99) {
        //         return "C";

        //     } else if ($percent >= 50.00 || $percent >= 59.99) {
        //         return "D";

        //     } else {

        //         return "F";
        //     }
        // },
        getAttendance(s){

            this.items = JSON.parse(localStorage.getItem("info"))

            var class_id = localStorage.getItem("class_id")


            var bodyFormData = new FormData();
            bodyFormData.append('class_id', class_id);
            bodyFormData.append('semester_id', s);
            bodyFormData.append('student_id', this.items.student_id);
         
            axios.post('http://api.isbbcambodia.org/isbb/public/api/countattendance', bodyFormData).then((data) => {

                 this.attendanc_data = data.data.data

            }).catch((error) => {
                
            })
        }

    },

    created() {
        this.score = 0
        this.getAttendance(1)
        
        var type_class = localStorage.getItem("type_class")
        this.typeclass =  localStorage.getItem("type_class")
        if (type_class == 'secondary') {


            this.url_api = 'http://api.isbbcambodia.org/isbb/public/api/api_reponse_secondary'

        }
        else if (type_class == 'uppersecondary') {
            
            this.url_api = 'http://api.isbbcambodia.org/isbb/public/api/api_response_upper_secondary'

        }

        else {

            this.url_api = ' http://api.isbbcambodia.org/isbb/public/api/api_reponse_primary'

        }


        this.items = JSON.parse(localStorage.getItem("info"))

        var class_id = localStorage.getItem("class_id")

        var academic = localStorage.getItem("academic")
        


        var bodyFormData = new FormData();
        bodyFormData.append('id_class', class_id);
        bodyFormData.append('id_semester', this.semester);
        bodyFormData.append('id_student', this.items.student_id);
        bodyFormData.append('academic', academic)
        axios.post(this.url_api, bodyFormData).then((data) => {
         
            if(data.data.data.length == 0 )
            {
            
                this.score = 1
                console.log(this.score)
            }else{
                this.score = data.data.data
                this.grade_show = this.score[0].grade
                this.year_show = this.score[0].year
                this.semester_show = "Semester : " + this.score[0].semester_id + " " + this.score[0].semester_name + " "
                this.totalScore = this.score.reduce((sum, transaction) => {
                    return sum += parseFloat(transaction.Total_score);
                }, 0);


                // new code for count subject 
                var countSubject = this.score.reduce((c, transaction) => {
                        console.log(transaction.Total_score)
                        if (transaction.Total_score !=0 || transaction.Total_score == null)
                            return c += 1;
                        else
                            return c += 0;
                    
                    
                    }, 0);
    
                console.log(countSubject)    
                this.totalScore = parseFloat(this.totalScore) / countSubject
                // end new code


                // this.totalScore = parseFloat(this.totalScore) / this.score.length

                this.home_room = data.data.home_room
            }
          

        }).catch((error) => {
            this.score = 1
        })
    }
}
// updating date : 25-10-2023
// updating check arrage subject not upload to godday


/// Finish process : Updated to gooaddy



/// updating for academic year 2023-2024 subject to geography to globalproperstive

// Finish Process : upladed to godaddy ( 1.0.4)

</script>